export default __webpack_public_path__ + "static/media/virtual-hr.7206e0ba.svg";